export enum FieldType {
  Text,
  Number,
  Dropdown,
  Link
};
